// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const liepard: PokeData = {
  "id": 510,
  "name": "liepard",
  "height": 11,
  "weight": 375,
  "base_experience": 156,
  "types": [
    PokeType.DARK
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "growl",
    "fury-swipes",
    "slash",
    "pursuit",
    "fake-out",
    "torment",
    "taunt",
    "assist",
    "snatch",
    "assurance",
    "sucker-punch",
    "night-slash",
    "nasty-plot",
    "hone-claws",
    "play-rough"
  ],
  "moves": [
    "scratch",
    "growl",
    "pursuit",
    "snatch",
    "night-slash",
    "play-rough",
    "quash",
    "phantom-force",
    "snarl",
    "bite",
    "lash-out",
    "night-daze",
    "dark-bargain"
  ],
  "evolution_chain": {
    "id": 261,
    "item": null,
    "species": [
      {
        "name": "purrloin",
        "order": 510,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "liepard",
        "order": 511,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 509,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 91,
    "speed": 169,
    "ability_power": 140
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
